//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import qAuStatusInfo from "@/components/Generics/qAuStatusInfo.vue";
import {
    convertAndFormatTimeToLocal,
    setPluginIcon
} from "@/assets/js/appFunc";
import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";

export default {
    components: { qAuStatusInfo, AQCard },
    props: {
        api: {
            type: Object,
            default: () => {}
        },
        instanceName: {
            type: String,
            default: ""
        },
        instanceStatus: {
            type: String,
            default: ""
        },
        apiVariable: {
            type: Boolean,
            default: false
        },
        blockchain: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            readonly: true
        };
    },
    computed: {
        valueForName() {
            return this.apiVariable
                ? this.api.apiGivenName
                : this.api.smartContractName;
        },
        extecutedOn() {
            return convertAndFormatTimeToLocal(
                this.api.execStartDate,
                APP_DATE_DOT_FORMAT
            );
        },
        instanceType() {
            return this.apiVariable
                ? this.api.apiType
                : this.api.blockchainType;
        },
        methodName() {
            return this.apiVariable
                ? this.api.methodName
                : this.api.functionName;
        },
        instanceUrl() {
            return this.apiVariable ? this.api.url : this.api.channel;
        },
        locationHost() {
            return this.apiVariable ? this.api.location : this.api.host;
        }
    },
    methods: {
        convertAndFormatTimeToLocal,
        setPluginIcon
    }
};
